import { render, staticRenderFns } from "./MyLikedDishes.vue?vue&type=template&id=5921a4a4&scoped=true"
import script from "./MyLikedDishes.vue?vue&type=script&lang=js"
export * from "./MyLikedDishes.vue?vue&type=script&lang=js"
import style0 from "./MyLikedDishes.vue?vue&type=style&index=0&id=5921a4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5921a4a4",
  null
  
)

export default component.exports